import { render, staticRenderFns } from "./clipboard_button.vue.js?vue&type=template&id=dd333fde!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./clipboard_button.vue?vue&type=template&id=dd333fde"
import script from "./clipboard_button.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./clipboard_button.vue?vue&type=script&lang=js"
export * from "./clipboard_button.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./clipboard_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd333fde')) {
      api.createRecord('dd333fde', component.options)
    } else {
      api.reload('dd333fde', component.options)
    }
    module.hot.accept("./clipboard_button.vue.js?vue&type=template&id=dd333fde!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./clipboard_button.vue?vue&type=template&id=dd333fde", function () {
      api.rerender('dd333fde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/clipboard_button.vue"
export default component.exports